import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { apiGet, type Trip } from '~/lib/api';

export function Trips() {
  const [trips, setTrips] = useState<Trip[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    apiGet<{ trips: Trip[] }>('/api/admin/trips')
      .then((data) => setTrips(data.trips))
      .catch((e: Error) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  const formatPrice = (cents: number | null) =>
    cents == null ? '—' : `$${(cents / 100).toFixed(0)}`;

  return (
    <div className="trc-page">
      <header className="trc-page-header">
        <p className="trc-eyebrow">Catalog</p>
        <h1 className="trc-osw trc-page-title">Trips</h1>
      </header>
      {loading && <p>Loading…</p>}
      {error && <p className="trc-error">Error: {error}</p>}
      {!loading && !error && trips.length === 0 && (
        <p className="trc-page-empty">No trips yet.</p>
      )}
      {trips.length > 0 && (
        <ul className="trc-trip-list">
          {trips.map((t) => (
            <li key={t.id} className="trc-trip-row">
              <Link to={`/trips/${t.slug}`} className="trc-trip-link">
                <strong>{t.name}</strong>
                <span className="trc-trip-meta">{formatPrice(t.price_adult_cents)} · cap {t.capacity}</span>
                <span className="trc-trip-slug">{t.slug}</span>
                <span className="trc-trip-status">{t.status}</span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
